var _style, _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRestartLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 800 270",
    style: {
      enableBackground: "new 0 0 800 270"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FDC300;}\n\t.st1{fill:#6C829B;}\n\t.st2{fill:#FFDA6F;}\n\t.st3{fill:#FFF3D8;}\n\t.st4{fill:#A7B6C5;}\n\t.st5{fill:#F3F5F7;}\n\t.st6{fill:#FFFFFF;}\n\t.st7{display:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Farben"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Logo-Wortmarke"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Logo-Bildmarke"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M397.1,134h-77.3c0.4,18.7,14.9,33.9,34.1,33.9c13.9,0,24.7-7.8,29.9-16.1l10.2,8 c-11,13.9-24.7,19.7-40.1,19.7c-27.7,0-48.2-20.9-48.2-49s20.5-49,47-49c29.3,0,44.6,20.7,44.6,46.2 C397.3,129.4,397.3,131.6,397.1,134z M383.6,123.2c-0.8-17.5-11.6-30.5-30.9-30.5c-18.1,0-31.5,14.5-32.7,30.5H383.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M471.9,105.9c-4-7.8-12.6-13.2-22.9-13.2c-9.8,0-19.7,4.2-19.7,14.5c0,8.8,7,12.8,22.3,15.9 c21.9,4.6,32.3,12.8,32.3,27.3c0,21.3-17.9,28.9-35.1,28.9c-14.1,0-28.3-5.6-36.9-18.1l10.8-8c4.8,8.2,14.9,14.5,25.9,14.5 c11.6,0,21.9-4.2,21.9-16.3c0-9.8-9.8-13.7-27.5-17.9c-11-2.6-26.7-7.4-26.7-25.1c0-18.9,16.3-27.1,33.3-27.1 c13,0,26.7,6.2,32.7,16.7L471.9,105.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M549.8,95.1h-26.3v54.4c0,13.9,5.8,17.1,13.9,17.1c3.8,0,8.2-1.2,11.8-3l0.6,11.8c-4.8,1.8-9.8,2.8-15.9,2.8 c-10,0-23.9-4.4-23.9-24.9V95.1h-12.8V83.7H510V57.4h13.6v26.3h26.3V95.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M627,116.8c0-16.1-8.8-24.1-24.9-24.1c-11,0-21.1,4.4-27.7,11l-7.6-9c7.6-7.6,20.7-13.4,36.7-13.4 c20.1,0,36.3,11.2,36.3,33.9v40.9c0,7.2,0.6,15.7,1.6,20.9h-12.2c-0.8-4.6-1.4-10.2-1.4-15.1h-0.4c-8.6,12.4-18.9,17.5-33.9,17.5 c-14.1,0-32.3-7.6-32.3-28.3c0-28.7,31.7-31.3,65.8-31.3V116.8z M623.1,130.4c-22.1,0-47.8,2.4-47.8,20.1 c0,13.4,11.4,17.7,21.9,17.7c19.1,0,29.9-14.3,29.9-30.9v-7H623.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M667.7,83.7h13c0.4,5,0.8,12,0.8,15.9h0.4c5.2-10.8,15.4-15.9,29.9-15.9h2.4v11.4H711 c-15.8,0-28.9,9.2-28.9,34.1V177h-13.6v-72.7C668.5,99.3,668.3,90.1,667.7,83.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M251.2,83.7h13c0.4,5,0.8,12,0.8,15.9h0.4c5.2-10.8,15.4-15.9,29.9-15.9h2.4v11.4h-3.1 c-15.8,0-28.9,9.2-28.9,34.1V177H252v-72.7C252,99.3,251.8,90.1,251.2,83.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M774.8,95.1h-26.3v54.4c0,13.9,5.8,17.1,13.9,17.1c3.8,0,8.2-1.2,11.8-3l0.6,11.8c-4.8,1.8-9.8,2.8-15.9,2.8 c-10,0-23.9-4.4-23.9-24.9V95.1h-12.8V83.7H735V57.4h13.6v26.3h26.3V95.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M280.3,220.3c-1.7-2.7-5.5-4.7-9.4-4.7c-8.5,0-13.4,6.9-13.4,14.8c0,7.8,4.9,14.8,13.5,14.8 c4.1,0,7.7-1.7,9.8-4.5l5.4,4.9c-3.5,4-8.7,6.4-15.3,6.4c-12.6,0-22-8.5-22-21.6c0-12.9,9.3-21.6,21.8-21.6c5.8,0,12,2.3,15.4,6.7 L280.3,220.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M372.7,224.4c0-6-4.1-9-10.1-9c-4.6,0-8.9,2-11.7,4.7l-4.3-5.2c4-3.8,10.1-6.1,16.7-6.1 c11.7,0,17.1,7,17.1,16.1v17.9c0,2.8,0.2,6.1,0.6,8.1h-7.3c-0.4-1.8-0.7-4-0.7-5.9h-0.3c-2.9,4.4-7.6,6.9-13.7,6.9 c-6.5,0-14.8-3.2-14.8-12.6c0-12.3,14.7-13.8,28.5-13.8V224.4z M370.7,231.3c-8,0-18.2,0.9-18.2,7.8c0,4.8,4.3,6.4,8.4,6.4 c7.6,0,11.8-5.1,11.8-12v-2.2H370.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M451.5,209.9h7.7c0.2,2.1,0.3,5.2,0.3,6.9h0.3c2.2-4.7,7-8,12.5-8c1.1,0,2.2,0.1,3.2,0.3l-0.3,7.5 c-1-0.3-2.4-0.4-3.7-0.4c-7.8,0-11.5,6.3-11.5,13.1v21.5h-8.1v-32.1C451.8,216.6,451.7,212.6,451.5,209.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M575.8,232.8h-32.5c0.3,7,6.1,12.4,13.3,12.4c5.5,0,9.6-2.8,11.9-6.2l5.7,4.6c-4.4,5.7-10.4,8.4-17.6,8.4 c-12.4,0-21.6-8.6-21.6-21.5c0-12.8,9.2-21.7,21.1-21.7c12.1,0,19.7,8.2,19.7,21.2C575.9,230.9,575.9,231.9,575.8,232.8z  M567.7,226.8c-0.2-6.5-4-11.6-11.5-11.6c-7,0-12.3,5.2-12.9,11.6H567.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M683.1,232.8h-32.5c0.3,7,6.1,12.4,13.3,12.4c5.5,0,9.6-2.8,11.9-6.2l5.7,4.6c-4.4,5.7-10.4,8.4-17.6,8.4 c-12.4,0-21.6-8.6-21.6-21.5c0-12.8,9.2-21.7,21.1-21.7c12.1,0,19.7,8.2,19.7,21.2C683.2,230.9,683.2,231.9,683.1,232.8z  M675,226.8c-0.2-6.5-4-11.6-11.5-11.6c-7,0-12.3,5.2-12.9,11.6H675z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M752.2,209.9h7.7c0.2,2.1,0.3,5.2,0.3,6.9h0.3c2.2-4.7,7-8,12.5-8c1.1,0,2.2,0.1,3.2,0.3l-0.3,7.5 c-1-0.3-2.4-0.4-3.7-0.4c-7.8,0-11.5,6.3-11.5,13.1v21.5h-8.1v-32.1C752.6,216.6,752.5,212.6,752.2,209.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M127.8,114.9c1.1-40.8-18.1-96.9-18.1-96.9s29.1,24.2,62.1,68.6c53.5,71.9-0.2,140-0.2,140L29,184.1 C29,184.1,126,185,127.8,114.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M34.4,175.7c17.8-2.1,57.5-7.8,75.1-32.6V57.3L34.4,175.7z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "23.8,192.4 109.5,251 109.5,217.9  "
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Hilfslinien",
    className: "st7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestartLogo);
export default __webpack_public_path__ + "static/media/restart_logo.29bbe34ffeb77081955b5f306606b804.svg";
export { ForwardRef as ReactComponent };